export default "__VITE_ASSET__yzVT3btL__"